import { render } from "./ConsentsList.vue?vue&type=template&id=628ce353&ts=true"
import script from "./ConsentsList.vue?vue&type=script&lang=ts"
export * from "./ConsentsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Consents/ConsentsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "628ce353"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('628ce353', __exports__)) {
    api.reload('628ce353', __exports__)
  }
  
  module.hot.accept("./ConsentsList.vue?vue&type=template&id=628ce353&ts=true", () => {
    api.rerender('628ce353', render)
  })

}


export default __exports__